import { render } from "./humanityFiveMuseum.vue?vue&type=template&id=147304c7&scoped=true"
import script from "./humanityFiveMuseum.vue?vue&type=script&lang=js"
export * from "./humanityFiveMuseum.vue?vue&type=script&lang=js"

import "./humanityFiveMuseum.vue?vue&type=style&index=0&id=147304c7&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147304c7"]])

export default __exports__